<template>
  <b-form class="login-form" @submit.prevent="onSubmit">
    <b-alert
        :variant="formAlertType"
        show
        v-if="!formState.processing && (formState.message.length > 0 || formState.success)"
    >
      <template v-if="formState.success">
        <p>Your password has been successfully updated</p>
      </template>
      <template v-else>
        {{ formState.message }}
      </template>
    </b-alert>

    <b-form-group label="Email address">
      <b-form-input
          v-model.trim="formData.email"
          type="text"
          placeholder="Email address"
          :state="emailInvalid"
      />
      <b-form-invalid-feedback :state="emailInvalid">
        {{ formValidation.email }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="New password">
      <b-form-input
          v-model.trim="formData.password"
          type="password"
          placeholder="Enter new password"
          :state="emailInvalid"
      />
      <b-form-invalid-feedback :state="passwordInvalid">
        {{ formValidation.password }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Confirm New password">
      <b-form-input
          v-model.trim="formData.password_confirmation"
          type="password"
          placeholder="Enter new password again"
      />
    </b-form-group>

    <b-button type="submit" variant="primary" block class="login-submit" :disabled="formState.processing">
      {{ !formState.processing ? 'Submit' : 'Processing...' }}
    </b-button>
  </b-form>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  computed: {
    formAlertType: function () {
      return this.formState.success ? 'success' : 'danger';
    },
    emailInvalid: function () {
      return this.formValidation.email.length > 0 ? false : null;
    },
    passwordInvalid: function () {
      return this.formValidation.password.length > 0 ? false : null;
    }
  },
  data() {
    return {
      formData: {
        email: this.$route.query.email,
        token: this.$route.params.token,
        password: '',
        password_confirmation: ''
      },
      formValidation: {
        email: '',
        password: ''
      },
      formState: {
        success: null,
        message: '',
        processing: false
      }
    }
  },
  methods: {
    onSubmit() {
      this.formState.processing = true;
      this.$api.post(API_ROUTES.RESET_PASSWORD, this.formData).then(({data}) => {
        this.formState.success = true;
        this.formState.message = '';
        setTimeout(() => {
          this.$router.push({name: 'login'});
        }, 2000);
      }).catch(({response: {data}}) => {
        this.formState.success = false;
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in this.formValidation) {
            if (typeof data.errors[fieldName] !== 'undefined') {
              this.formValidation[fieldName] = data.errors[fieldName].join(', ');
            } else if (this.formValidation[fieldName].length > 0) {
              this.formValidation[fieldName] = '';
            }
          }
        }
        if (typeof data.message !== 'undefined') {
          this.formState.message = data.message;
        }
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
